import Title from 'client/common/components/agencies-title';

export default Title;
